import { render, staticRenderFns } from "./cartridge-info.vue?vue&type=template&id=0b1170de&"
import script from "./cartridge-info.vue?vue&type=script&lang=js&"
export * from "./cartridge-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1170de')) {
      api.createRecord('0b1170de', component.options)
    } else {
      api.reload('0b1170de', component.options)
    }
    module.hot.accept("./cartridge-info.vue?vue&type=template&id=0b1170de&", function () {
      api.rerender('0b1170de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/cartridge-list/cartridge-info.vue"
export default component.exports